/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import {
    object, func, string, shape,
} from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    triggerAddPassportByRemoveGiftCard,
    hidePassportModalToRemoveGC,
} from '../../../../../../../../../state/ducks/Passport/Passport-Action';

const styles = (theme) => ({
    dialog: {
        padding: '10px',
    },
    dialogTitle: {
        fontWeight: 600,
    },
    dialogContent: {
        padding: '19px 0px',
        fontSize: '17px',
        textAlign: 'left',
    },
    btnStyle: {
        width: '98%',
    },
    btnYes: {
        backgroundColor: theme.palette.primaryButton,
    },
});

const AddPassportModal = ({
    classes, btnYesRemoveGCAndApplyPassport, btnNoDontRemoveGC, pageType, history,
}) => (
    <Dialog
        id="passport-modal-rm-gc"
        data-testid="passport-modal-rm-gc" // unit test
        open
        classes={{
            paper: classes.dialog,
        }}
    >
        <p className={classes.dialogContent}>
            Celebration Passport cannot be purchased with Gift Card, Do you want to continue adding Passport by removing applied Gift Card ?
        </p>
        <Grid container spacing={2}>
            <Grid item xs={6} align="center">
                <Button
                    id="btnYesApplyPassport"
                    data-testid="btnYesApplyPassport" // unit test
                    className={`${classes.btnStyle} ${classes.btnYes}`}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        btnYesRemoveGCAndApplyPassport(pageType, history);
                    }}
                >
                    Yes
                </Button>
            </Grid>
            <Grid item xs={6} align="center">
                <Button
                    id="btnNoDontApplyPassport"
                    data-testid="btnNoDontApplyPassport" // unit test
                    className={classes.btnStyle}
                    variant="contained"
                    color="primary"
                    onClick={btnNoDontRemoveGC}
                >
                    No
                </Button>
            </Grid>
        </Grid>
    </Dialog>
);

const mapDispatchToProps = (dispatch) => ({
    btnYesRemoveGCAndApplyPassport: bindActionCreators(triggerAddPassportByRemoveGiftCard, dispatch),
    btnNoDontRemoveGC: bindActionCreators(hidePassportModalToRemoveGC, dispatch),
});

AddPassportModal.propTypes = {
    classes: object.isRequired,
    btnYesRemoveGCAndApplyPassport: func.isRequired,
    btnNoDontRemoveGC: func.isRequired,
    pageType: string,
    history: shape({
        location: shape({
            pathname: string,
        }),
    }),
};

AddPassportModal.defaultProps = {
    pageType: 'payment',
    history: {},
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(AddPassportModal));
